/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Percentage_LabelInputs */

const en_admin_discounts_percentage_label = /** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage`)
};

const de_admin_discounts_percentage_label = /** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozent`)
};

const es_admin_discounts_percentage_label = /** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcentaje`)
};

const fr_admin_discounts_percentage_label = /** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourcentage`)
};

const nl_admin_discounts_percentage_label = /** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage`)
};

/** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */
const it_admin_discounts_percentage_label = en_admin_discounts_percentage_label;

/** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */
const pt_br2_admin_discounts_percentage_label = en_admin_discounts_percentage_label;

/** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */
const pl_admin_discounts_percentage_label = en_admin_discounts_percentage_label;

/** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */
const hu_admin_discounts_percentage_label = en_admin_discounts_percentage_label;

/** @type {(inputs: Admin_Discounts_Percentage_LabelInputs) => LocalizedString} */
const ro_admin_discounts_percentage_label = en_admin_discounts_percentage_label;

/**
* | output |
* | --- |
* | "Percentage" |
*
* @param {Admin_Discounts_Percentage_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_percentage_label = /** @type {((inputs?: Admin_Discounts_Percentage_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Percentage_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_percentage_label(inputs)
	if (locale === "de") return de_admin_discounts_percentage_label(inputs)
	if (locale === "es") return es_admin_discounts_percentage_label(inputs)
	if (locale === "fr") return fr_admin_discounts_percentage_label(inputs)
	if (locale === "nl") return nl_admin_discounts_percentage_label(inputs)
	if (locale === "it") return it_admin_discounts_percentage_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_percentage_label(inputs)
	if (locale === "pl") return pl_admin_discounts_percentage_label(inputs)
	if (locale === "hu") return hu_admin_discounts_percentage_label(inputs)
	return ro_admin_discounts_percentage_label(inputs)
});
export { admin_discounts_percentage_label as "admin.discounts.percentage_label" }